import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getContractFeesCount } from '../../../Redux/Actions/Contract.Fees.Actions';
import { getContractTeamCount } from '../../../Redux/Actions/Contract.Teams.Actions';
import { getScriptAllocationCount } from '../../../Redux/Actions/Script.Allocation.Actions';
import { getScriptDatesCount } from '../../../Redux/Actions/Script.Dates.Actions';

export const useInitialCountsLoad = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { qualification_year, appointment_types } = useSelector(state => state.contract_globals);
	const isFeesLoaded = useSelector(state => state.fees.isLoaded);
	const isTeamsLoaded = useSelector(state => state.teams.isLoaded);
	const isAllocationLoaded = useSelector(state => state.allocation.isLoaded);
	const isScriptDatesLoaded = useSelector(state => state.scriptdates.isLoaded);
	const dispatch = useDispatch();

	useEffect(() => {
		const initLoad = () => {
			setIsLoading(true);
			const selected_year = qualification_year.selected;
			const selected_types = appointment_types.selected;
			dispatch(getContractFeesCount(selected_types, selected_year));
			dispatch(getContractTeamCount(selected_types, selected_year));
			dispatch(getScriptAllocationCount(selected_types, selected_year));
			dispatch(getScriptDatesCount(selected_types, selected_year));
			if (isFeesLoaded && isTeamsLoaded && isAllocationLoaded && isScriptDatesLoaded) {
				setIsLoading(false);
			}
		};
		initLoad();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [qualification_year, appointment_types, isFeesLoaded, isTeamsLoaded, isAllocationLoaded, isScriptDatesLoaded]);
	return { isLoading };
};
